export {Lang, configure, getConfig} from './utils/configure';
export * from './components';
export * from './hooks';
export * from './utils/dom';
export type {StringWithSuggest} from './types/utils';
